import React from 'react';
import PropTypes from 'prop-types';

const ToggleSwitch = ({field,label, onChange}) => {
    return (
        <div className="d-flex align-items-center mb-3">
            <label className="form-check-label label-style me-3" htmlFor="toggleSwitch">
                {label}
            </label>
            <label className="switch">
                <input
                    type="checkbox"
                    id="toggleSwitch"
                    checked={field.value ? field.value : false}
                    onChange={onChange}
                />
                <span className="slider"></span>
            </label>
        </div>
    );
};



export default ToggleSwitch;
